module.exports = __webpack_public_path__ + "img/courier-xpologistics.37ff61f6.svg";